<template>
  <v-app>
    <v-card
            class="pb-2"
    >
      <v-container fluid>
        <v-row class="mb-2">
          <v-col>
            <v-img
                alt="ununx Logo"
                class="shrink mt-1 ml-n2"
                contain
                src="./assets/ununx.png"
                transition="scale-transition"
                width="120"
                height="27"
            />

          </v-col>
<!--          <h2 class="ml-2 mt-2 font-weight-light text-blue">ununx</h2>-->
          <v-spacer/>
          <v-menu>
            <template v-slot:activator="{ props }">
<!--              <v-btn text :color="networkColor(this.$store.state.chain)" @click="selectArbitrumGoerli" class="v-btn&#45;&#45;size-x-small pa-0 mt-2 ml-1 text-start">{{networkHint(this.$store.state.chain)}}</v-btn>-->

              <v-btn
                  flat
                  class="mt-2 font-weight-light"
                  :color="showAccountColor(this.$store.state.wallet.account)"
                  @click="copyPasteAccount"
              >
                <v-icon small color="blue" class="mr-1" v-if="this.$store.state.wallet.account!==''">mdi-content-copy</v-icon>
                {{showAccount(this.$store.state.wallet.account)}}
                <v-tooltip max-width="350" activator="parent" location="bottom">copy account address</v-tooltip>
              </v-btn>
              <v-btn
                  flat
                  v-bind="props"
                  variant="outlined"
                  class="mt-2 border font-weight-light"
                  :color="networkColor"
              >
                <v-avatar size="x-small" class="mr-2">
                  <v-img
                      alt="ununx.com"
                      :src="networkLogo"
                  />
                </v-avatar>
                {{networkHint}}
                <v-icon small class="ml-2">mdi-chevron-down</v-icon>
                <v-tooltip max-width="350" activator="parent" location="bottom">select network connect wallet</v-tooltip>
              </v-btn>

            </template>

            <v-list>

              <v-list-item>
                <v-list-item-subtitle>
                  <v-btn text x-small class="font-weight-light" @click="selectArbitrumSepolia">
                    <v-avatar size="x-small" class="mr-2">
                    <v-img
                        alt="ununx.com"
                        src="img/logo/arbitrum120.png"
                    />
                    </v-avatar>
                    Arbitrum Sepolia Test
                  </v-btn>
                </v-list-item-subtitle>
              </v-list-item>
<!--              <v-list-item>-->
<!--                <v-list-item-subtitle>-->
<!--                  <v-btn text x-small class="font-weight-light" @click="selectLineaGoerli">-->
<!--                    <v-avatar size="x-small" class="mr-2">-->
<!--                    <v-img-->
<!--                        alt="ununx.com"-->
<!--                        src="img/logo/lineaGoerli.png"-->
<!--                    />-->
<!--                    </v-avatar>-->
<!--                    Linea Goerli Test-->
<!--                  </v-btn>-->
<!--                </v-list-item-subtitle>-->
<!--              </v-list-item>-->
<!--              <v-list-item>-->
<!--              <v-list-item-subtitle>-->
<!--                <v-btn text x-small class="font-weight-light" @click="selectEthereumMain">Ethereum Main</v-btn>-->
<!--              </v-list-item-subtitle>-->
<!--              </v-list-item>-->

            </v-list>
          </v-menu>

          <!--        <v-menu>-->
          <!--          <template v-slot:activator="{ props }">-->
          <!--            <v-btn-->
          <!--                icon-->
          <!--                color="blue"-->
          <!--                v-bind="props "-->
          <!--                v-on="on"-->
          <!--            >-->
          <!--              <v-icon large>mdi-dots-vertical</v-icon>-->
          <!--            </v-btn>-->
          <!--          </template>-->
          <!--        </v-menu>-->

        </v-row>

        <v-row class="mt-2">
          <v-btn flat x-small class="px-0 ml-2 font-weight-light" @click="goAirdrop">
            <v-badge dot color="red">
              Airdrop
            </v-badge>
          </v-btn>
          <v-btn flat x-small class="px-0 ml-1 font-weight-light" @click="goHome">Trade</v-btn>
          <v-btn flat x-small class="px-0 ml-1 font-weight-light" @click="goMarket">Market</v-btn>
          <!--      <v-btn text x-small class="px-0 font-weight-light" @click="goSwap">Swap</v-btn>-->
          <v-btn flat x-small class="px-0 ml-1 font-weight-light" @click="goFaucet">Faucet</v-btn>
          <v-btn flat x-small class="px-0 ml-1 font-weight-light" @click="goAccount">Account</v-btn>
          <!--      <v-btn text x-small class="px-0 font-weight-light" @click="goHelp">Help</v-btn>-->
        </v-row>
      </v-container>
    </v-card>

    <v-main>
      <router-view/>
    </v-main>

<!--    <v-divider class="mt-12"/>-->
    <v-footer
        class="mt-3 d-flex flex-column"
        style="font-family: 'Courier New'"
    >
      <v-container fluid>

        <v-row dense>
        <v-col cols="12" md="8" sm="12" class="text-body-2 font-weight-light">
          <v-row>
            <div>
              ununx is decentralized blockchain derivatives exchange,aggregate quality assets around the world full stack trading,you can trade cryptocurrencies, stocks, funds, futures and forex, set stop loss and win take profit price，no closeing fee will be charged for the loss order,No-productive price,no borrowing fee,no funding rates. asset transfer protect your security and privacy,all data on blockchain,orders are permanently available.
            <a :href='"https://ununx.com/file/whitebook_en.pdf"' target="_blank" rel="noopener">more</a>
            </div>
          </v-row>
          <v-row class="mt-5">
            Backed by the best:
          </v-row>
          <v-row class="border-t px-0 mb-9">
            <v-img
                class="shrink mt-2"
                contain
                src="./assets/Pyth.svg"
                transition="scale-transition"
                height="35"
                width="90"
            />
<!--            <v-img-->
<!--                class="shrink mt-2"-->
<!--                contain-->
<!--                src="./assets/Distribted.svg"-->
<!--                transition="scale-transition"-->
<!--                height="35"-->
<!--            />-->
            <v-img
                class="shrink mt-3 ml-1"
                contain
                src="./assets/Gusto.svg"
                transition="scale-transition"
                height="30"
                width="90"
            />
            <v-img
                class="shrink mt-3"
                contain
                src="./assets/IVC.svg"
                transition="scale-transition"
                height="30"
                width="60"
            />
            <v-img
                class="shrink mt-3 mr-1"
                contain
                src="./assets/Kindred.svg"
                transition="scale-transition"
                height="30"
                width="80"
            />
            <v-img
                class="shrink mt-2"
                contain
                src="./assets/Paradigm.svg"
                transition="scale-transition"
                width="110"
                height="30"
            />
            <v-img
                class="shrink mt-3"
                contain
                src="./assets/4RC.svg"
                transition="scale-transition"
                width="80"
                height="25"
            />
          </v-row>
        </v-col>
          <v-spacer/>
      <v-col cols="12" md="4" sm="12">
        <v-row class="justify-end">
          <a href="https://discord.gg/y6dWX9MVCV" target="_blank" style="text-decoration-line: none">
          <v-btn
              density="compact"
              class="text-grey-darken-1 mr-4"
              icon="mdi-discord"
          ></v-btn>
          </a>
          <a href="https://github.com/ununx/ununx" target="_blank" style="text-decoration-line: none">
          <v-btn
              density="compact"
              class="text-grey-darken-1 mr-4"
              icon="mdi-github"
          >
          </v-btn>
          </a>
          <a href="https://twitter.com/ununx_com" target="_blank" style="text-decoration-line: none">
          <v-btn
              density="compact"
              class="text-grey-darken-1 mr-4"
              icon="mdi-twitter"
          ></v-btn>
          </a>
<!--          class="text-purple-accent-3"-->
          <v-btn
              density="compact"
              class="text-grey-darken-1"
              icon="mdi-wechat"
          ></v-btn>
        </v-row>
        <v-row class="mt-5 mb-2 justify-end font-weight-light">
          ununx@ununx.com
        </v-row>
        <v-row class="justify-end font-weight-light">
          +86 18664058318
        </v-row>

        <v-row class="justify-end mt-5">
          <v-spacer/>
          <div>
          </div>
          <div class="text-grey text-body-2">© 2024 ununx.com, Inc.</div>
        </v-row>
      </v-col>

        </v-row>
      </v-container>
    </v-footer>

    <!-- 含确认和取消按钮的对话框 -->
    <v-dialog
        v-model="this.$store.state.ConfirmDialogShow"
        persistent
        max-width="520"
    >
      <v-card>
        <v-card-title class="font-weight-light text-button border-b">
          <v-row class="ml-1 py-1">
            {{this.$store.state.ConfirmDialog.title}}
          </v-row>
        </v-card-title>
        <v-card-text class="py-5 font-weight-light">
          <div>
            {{this.$store.state.ConfirmDialog.text1}}
          </div>
          <div class="mt-1">
            {{this.$store.state.ConfirmDialog.text2}}
          </div>
          <div class="mt-1">
            {{this.$store.state.ConfirmDialog.text3}}
          </div>
        </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="primary" @click="this.$store.state.ConfirmDialog.confirm = true, this.$store.state.ConfirmDialogShow = false ">
                    confirm
                  </v-btn>
                  <v-btn color="primary" @click="this.$store.state.ConfirmDialogShow = false">
                    cancel
                  </v-btn>
                </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 无交互对话框 -->
    <v-dialog
        v-model="this.$store.state.DialogShow"
        persistent
        max-width="520"
    >
      <v-card>
        <v-card-title class="font-weight-light text-button border-b">
          <v-row class="ml-1 py-1">
            {{this.$store.state.dialog.title}}
            <v-spacer/>
            <v-btn
                size="small"
                density="compact"
                variant="text"
                icon="mdi-close"
                @click="PublicDialogClose"
            ></v-btn>
          </v-row>
        </v-card-title>
        <v-card-text class="py-5 font-weight-light">
          <div>
            {{this.$store.state.dialog.text1}}
          </div>
          <div class="mt-1">
            {{this.$store.state.dialog.text2}}
          </div>
          <div class="mt-1">
            {{this.$store.state.dialog.text3}}
          </div>
        </v-card-text>

        <!--        <v-divider></v-divider>-->
        <!--        <v-card-actions>-->
        <!--          <v-spacer></v-spacer>-->
        <!--          <v-btn color="primary" @click="this.$store.state.DialogShow = false">-->
        <!--            close-->
        <!--          </v-btn>-->
        <!--        </v-card-actions>-->
      </v-card>
    </v-dialog>
    <!-- 公用提示框     -->
    <v-snackbar
        v-model="this.$store.state.Snackbar.show"
        :color="this.$store.state.Snackbar.type"
    >
      {{ this.$store.state.Snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="this.$store.state.Snackbar.show = false">
          x
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import {block, isStrEmpty} from "@/common"
import Ipyth from "@/pyth";
import Istore from "@/store";
export default {
  name: 'App',
  data: () => ({
    TooltipShow: false,
    networkLogo: '',
    networkColor: '',
    networkHint: '',
  }),
  computed:{
    ellipsis: function () {
      return function (value) {
        if (!value) return ''
        if (value.length > 20) {
          return value.slice(0, 7) + '...' + value.slice(-4)
        }
        return value
      }
    },
    ellipsisLong: function () {
      return function (value) {
        if (!value) return ''
        if (value.length > 20) {
          return value.slice(0, 9) + '...' + value.slice(-7)
        }
        return value
      }
    },

    // 用于显示用户登录的帐号
    showAccount: function () {
      return function (value) {
        if (!value || isStrEmpty(value)) {
          return 'Login wallet'
        } else {
          return value.slice(0, 9) + '...' + value.slice(-7)
        }
      }
    },

    // 用于显示用户登录的帐号
    showAccountColor: function () {
      return function (value) {
        if (!value || isStrEmpty(value)) {
          return 'red'
        }
      }
    },

    // networkColor: function () {
    //   return function (chain) {
    //     // 需和networkHint判断条件保持一至，检查wallet的chainID
    //     if (['59140','421613'].indexOf(chain)===-1) {
    //       return 'red'
    //     } else {
    //       return 'green'
    //     }
    //   }
    // },
    //
    // // 根据网络ID修改提示信息
    // networkHint: function () {
    //   return function (chainID) {
    //     console.log('chain', chainID)
    //     switch (chainID) {
    //       case '421613':
    //         return 'Arbitrum Goerli'
    //       default:
    //         return 'invalid network'
    //     }
    //   }
    // },
  },
  created() {
    console.log('app launch')

    // 判断当前设备是否为手机
    const phoneFlag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if(!isStrEmpty(phoneFlag)) {
      //如果flag不为空，说明可以匹配到，是手机端
      this.$store.state.phone.isPhone=true
      this.$store.state.phone.orientation = screen.orientation.type
      console.log('isPhone', this.$store.state.phone)
    }
    // 监听窗口大小判断横竖屏
    window.onresize = () => {
      return (() => {
        // portrait-primary 竖屏, landscape-primary横屏
        this.$store.state.phone.orientation = screen.orientation.type // 把横竖屏的变化赋值
        console.log('window.onresize',this.$store.state.phone.orientation)
      })()
    }

    this.init()
  },
  watch: {
    // 当前帐号改变时重置帐号数据
    '$store.state.wallet.chain': function(newValue, oldValue) {
      console.log('app chain change',oldValue,'to',newValue)

        switch (newValue.toString()) {
          case '421614':
            this.networkColor = 'green'
            this.networkHint = 'Arbitrum Sepolia'
            this.networkLogo = 'img/logo/arbitrum120.png'
            return
          case '':
            this.networkColor = 'red'
            this.networkHint = 'connect metamask'
            this.networkLogo = ''
            return
          default:
            this.networkColor = 'red'
            this.networkHint = 'invalid network'
            this.networkLogo = ''
            return
        }
    }
  },
  // 在dapp退出前执行
  beforeUnmount() {
    // 注销订阅实时行情
    Ipyth.methods.UnSubscribe()
  },
  methods:{

    PublicDialogClose() {
      this.$store.state.DialogShow = false
      this.$store.state.dialog.title = ''
      this.$store.state.dialog.text1=''
      this.$store.state.dialog.text2=''
      this.$store.state.dialog.text3=''
    },
    async init() {
      if (!block.initWeb3()) {
        console.log('app init web3 error ')
        this.$store.state.wallet.chain = ''
        this.$store.state.wallet.account = ''
        block.SetChainInfo('')
        this.networkColor = 'red'
        this.networkHint = 'invalid network'
        this.networkLogo = ''
      } else {

        const chainid = await window.web3js.eth.getChainId()
        console.log('app init chain', chainid)
        if (!isStrEmpty(chainid.toString())) {
          this.$store.state.wallet.chain = chainid.toString()
          block.SetChainInfo(chainid.toString())
          switch (this.$store.state.wallet.chain.toString()) {
            case '421614':
              this.networkColor = 'green'
              this.networkHint = 'Arbitrum Sepolia'
              this.networkLogo = 'img/logo/arbitrum120.png'
              break
            case '':
              this.networkColor = 'red'
              this.networkHint = 'connect metamask'
              this.networkLogo = ''
              break
            default:
              this.networkColor = 'red'
              this.networkHint = 'invalid network'
              this.networkLogo = ''
              break
          }
        }

        const account = await window.web3js.eth.getAccounts()
        console.log('app init account', this.$store.state.wallet.account)
        if (account.length > 0 && !isStrEmpty(account[0])) {
          this.$store.state.wallet.account = account[0].toString()
          await block.getUsdtBalanceOf(this.$store.state.wallet.account)
          await block.getEthBalanceOf(this.$store.state.wallet.account)

        }
      }
    },

    // 选择预设网络，如果没有则增加
    async selectLineaGoerli() {

      if (typeof window.ethereum === 'undefined' || window.ethereum===undefined || !window.ethereum) {
        this.$store.state.DialogShow = true
        this.$store.state.dialog.title = 'Warning'
        this.$store.state.dialog.text1 = 'Invalid wallet please install and enable metamask'
        this.$store.state.dialog.text2 = 'https://metamask.io/download/'
        return
      }

      if(isStrEmpty(this.$store.state.wallet.account)) {
        const loginWalletRes = await block.loginWallet()
        console.log('loginWallet', loginWalletRes)
        if (loginWalletRes.IsError) {
          this.$store.state.DialogShow = true
          this.$store.state.dialog.title = 'Warning'
          this.$store.state.dialog.text1 = loginWalletRes.message
          return
        }
      }

      const getChainId = await window.web3js.eth.getChainId()

      const ChainID = '59140'
      if (getChainId.toString()===ChainID) {
        this.$store.state.DialogShow= true
        this.$store.state.dialog.title = 'Warning'
        this.$store.state.dialog.text1= 'select chain network is already running'
        return
      }

      let paramData = {
        chainName: 'Linea Goerli',
        chainId: window.web3js.utils.numberToHex(ChainID),
        blockExplorerUrls: ['https://goerli.lineascan.build'],
        rpcUrls: ['https://linea-goerli.infura.io/v3/'],
        // iconUrls: ['https://ununx.com/img/logo/arbitrum120.png'],
        // nativeCurrency: {        rpcUrls: ['https://Goerli.infura.io/v3'],

        //     name: 'ETH',
        //     symbol: 'ETH', // 2-6 characters long
        //     decimals: 18,
        // }
      }

      let {chainId} = paramData
      console.log('select linea', paramData)
      window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{chainId}],
      })
          .then(res => {
            console.log('wallet_switchEthereumChain res', ChainID,res)
            // if (isStrEmpty(res)) {
            //   this.$store.state.DialogShow= true
            //   this.$store.state.dialog.text1= 'network error, please try refresh or vpn'
            // }
          })
          .catch(switchError => {

            console.log('switch error', switchError)
            // 如果没有则添加该网络
            if (switchError.code === 4902) {
              window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [paramData],
              })
            }
          })
    },

    // 选择预设网络，如果没有则增加
    async selectArbitrumSepolia() {

      if (typeof window.ethereum === 'undefined' || window.ethereum===undefined || !window.ethereum) {
        this.$store.state.DialogShow = true
        this.$store.state.dialog.title = 'Warning'
        this.$store.state.dialog.text1 = 'Invalid wallet please install and enable metamask'
        this.$store.state.dialog.text2 = 'https://metamask.io/download/'
        return
      }

      if(isStrEmpty(this.$store.state.wallet.account)) {
        const loginWalletRes = await block.loginWallet()
        console.log('loginWallet', loginWalletRes)
        if (loginWalletRes.IsError) {
          this.$store.state.DialogShow = true
          this.$store.state.dialog.title = 'Warning'
          this.$store.state.dialog.text1 = loginWalletRes.message
          return
        }
      }

      const getChainId = await window.web3js.eth.getChainId()

      const ChainID = '421614'
      if (getChainId.toString()===ChainID) {
        this.$store.state.DialogShow= true
        this.$store.state.dialog.title = 'Warning'
        this.$store.state.dialog.text1= 'select chain network is already running'
        return
      }

      let paramData = {
        chainName: 'Arbitrum Sepolia',
        chainId: window.web3js.utils.numberToHex(ChainID),
        blockExplorerUrls: ['https://sepolia.arbiscan.io'],
        rpcUrls: ['https://sepolia-rollup.arbitrum.io/rpc'],
        // iconUrls: ['https://ununx.com/img/logo/arbitrum120.png'],
        // nativeCurrency: {        rpcUrls: ['https://Sepolia.infura.io/v3'],

        //     name: 'ETH',
        //     symbol: 'ETH', // 2-6 characters long
        //     decimals: 18,
        // }
      }

      let {chainId} = paramData
      window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{chainId}],
      })
          .then(res => {
            console.log('wallet_switchEthereumChain res', ChainID, res)
            // if (isStrEmpty(res)) {
            //   this.$store.state.DialogShow= true
            //   this.$store.state.dialog.text1= 'network error, please try refresh or vpn'
            // }
          })
          .catch(switchError => {

            console.log('switch error', switchError)
            // 如果没有则添加该网络
            if (switchError.code === 4902) {
              window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [paramData],
              })
            }
          })
    },

    /**
     * 复制当前帐号的内容可在任意地方粘贴
     */
    async copyPasteAccount() {

      if (typeof window.ethereum === 'undefined' || window.ethereum===undefined || !window.ethereum) {
        this.$store.state.DialogShow = true
        this.$store.state.dialog.title = 'Warning'
        this.$store.state.dialog.text1 = 'Invalid wallet please install and enable metamask'
        this.$store.state.dialog.text2 = 'https://metamask.io/download/'
        return
      }

      if (isStrEmpty(this.$store.state.wallet.account)){
        const loginWalletRes = await block.loginWallet()
        console.log('loginWallet', loginWalletRes)
        if (loginWalletRes.IsError) {
          this.$store.state.DialogShow = true
          this.$store.state.dialog.title = 'Warning'
          this.$store.state.dialog.text1 = loginWalletRes.message
          return
        }
        // this.$store.state.DialogShow = true
        // this.$store.state.dialog.title = 'warning'
        // this.$store.state.dialog.text1 = 'invalid account, please login wallet'
        // return
      }
      let input = document.createElement("input") // 直接构建input
      input.value = this.$store.state.wallet.account // 设置内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand("Copy") // 执行复制
      document.body.removeChild(input)  // 删除临时实例
    },

    /**
     * 复制
     * 复制的内容可在任意地方粘贴
     */
    copyPaste(copyContext) {
      if (isStrEmpty(copyContext)){
        this.$store.state.dialog.show= true
        this.$store.state.dialog.text1= 'invalid account, please login wallet '
        return
      }
      let input = document.createElement("input") // 直接构建input
      input.value = copyContext // 设置内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand("Copy") // 执行复制
      document.body.removeChild(input)  // 删除临时实例
    },

    // 切换语言
    changeLang() {
      console.log('lang', this.$i18n.locale)
      if (this.$i18n.locale === 'cn') {
        this.$i18n.locale = 'en'
        this.drawList[0].name = '中文'

      } else {
        this.$i18n.locale = 'cn'
        this.drawList[0].name = 'English'
      }
    },

    goItem(item) {
      if (item.link !== undefined && item.link !== null && item.link !== '') {
        switch (item.type) {
          case 'open': {
            window.open(item.link)
            break
          }
          case 'push': {
            this.$router.push(item.link)
            break
          }
          case 'changeLang': {
            this.changeLang()
            break
          }
        }
      }
    },
    goAirdrop() {
      const to = '/Airdrop'
      // 非当前页才跳转
      if (to!==this.$route.path) {
        this.$router.push(to)
      }
    },
    goHome() {
      const to = '/'
      // 非当前页才跳转
      if (to!==this.$route.path) {
        this.$router.push(to)
      }
    },
    goSwap() {
      const to = '/Swap'
      // 非当前页才跳转
      if (to!==this.$route.path) {
        this.$router.push(to)
      }

    },
    goMarket() {
      const to = '/Market'
      // 非当前页才跳转
      if (to!==this.$route.path) {
        this.$router.push(to)
      }
    },
    goFaucet() {
      const to = '/Faucet'
      // 非当前页才跳转
      if (to!==this.$route.path) {
        this.$router.push(to)
      }
    },

    goAccount() {
      const to = '/MyAccount'
      // 非当前页才跳转
      if (to!==this.$route.path) {
        this.$router.push(to)
      }
    },
    goHelp() {
      this.$store.state.HelpDialog=true

      // const to = '/Help'
      // // 非当前页才跳转
      // if (to!==this.$route.path) {
      //   this.$router.push(to)
      // }
    },
  }
}
</script>
